<template>
  <div class="h100 text-c">
    <cnd-icon
      name="cnd-delete"
      class="download-icon pointer"
      @click="deleteParam"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { MessageUtil, request } from '@cndinfo/cube-web-utils'

export default Vue.extend({
  data() {
    return {}
  },
  methods: {
    deleteParam() {
      request({
        url: `/paraminfo/remove/${this.params.data.sId}`,
        method: 'DELETE',
        noLoading: true
      })
        .then((res) => {
          MessageUtil.success(this.$t('tips.deletedSuccessfully'))
          this.params.update()
        })
        .catch((err) => {
          console.log(err)
        })
      // apiList
      //   .delList({}, `/paraminfo/remove/${this.params.data.sId}`)
      //   .then((res) => {
      //     MessageUtil.success(this.$t("tips.deletedSuccessfully"))
      //     this.params.update()
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //   })
    }
  }
})
</script>

<style scoped lang="scss">
.download-icon:hover,
.eyes-icon:hover {
  color: #66b1ff;
}
</style>
